import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { FormGroup, Row, Col, Input, Label, Button } from "reactstrap";
import Select from "react-select";
import funcionogramaService from "services/FuncionogramaService";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { FloppyDisk, Printer, SignOut } from "@phosphor-icons/react";
import { SendaCustomSwal } from "components/Common/SendaCustomSwal";

const CaracteristicaCargo = ({ onCloseClick, data }) => {
	const id = data?.id;
	const [cargos, setCargos] = useState([]);
	const [selectedCargo, setSelectedCargo] = useState();
	const [selectedInfos, setSelectedInfos] = useState({});
	const [editInfos, setEditInfos] = useState({}); // Estado para armazenar as edições do usuário

	const navigate = useNavigate();

	const customStyles = {
		option: (provided, state) => ({
			...provided,
			color: state.isSelected ? "blue" : "black",
			backgroundColor: "white",
			"&:hover": {
				backgroundColor: "#556ee6",
			},
		}),
	};

	async function getCargos() {
		try {
			const response = await funcionogramaService.get(id);
			const cargosInfo = response.map((item) => {
				return {
					value: item.id,
					label: item.name,
				};
			});
			setCargos(cargosInfo);
		} catch (error) {
			console.log(error);
		}
	}

	useEffect(() => {
		getCargos();
	}, []);

	const handleChangeCargo = (field) => {
		setSelectedCargo(field);
	};

	useEffect(() => {
		if (selectedCargo?.value) {
			getInfos(selectedCargo?.value);
		}
	}, [selectedCargo]);

	async function getInfos(cargoId) {
		try {
			const response = await funcionogramaService.getOne(cargoId);
			setSelectedInfos(response);
			setEditInfos(response); // Inicializar estado de edição com os dados obtidos
		} catch (error) {
			console.log(error);
		}
	}

	const handleChangeFieldValue = (field, value) => {
		// Atualiza o estado de edição quando o usuário modifica um campo
		setEditInfos((prevState) => ({
			...prevState,
			[field]: value,
		}));
	};

	const handleSave = async () => {
		try {
			await funcionogramaService.put({
				id: selectedCargo?.value,
				...editInfos,
			});
			getInfos(selectedCargo?.value); // Recarrega as informações atualizadas
			SendaCustomSwal.fire({
				iconHtml: '<i class="success-icon"></i>',
				title: "Sucesso",
				text: "Característica atualizada com sucesso!",
				customClass: {
					confirmButton: "custom-confirm-button",
				},
			});
		} catch (error) {
			const message = error?.response?.data?.message
				? error?.response?.data?.message
				: "Algo deu errado!";
			SendaCustomSwal.fire({
				iconHtml: '<i class="error-icon"></i>',
				title: "Oops...",
				text: message,
				customClass: {
					confirmButton: "custom-confirm-button",
				},
			});
		}
	};

	return (
		<>
			<Row className="py-1">
				<div className="hstack gap-2 justify-content-end mb-0">
					<Button
						style={{
							background: "none",
							padding: 10,
							cursor: "pointer",
							color: "black",
							marginLeft: 10,
						}}
						onClick={() => {
							const baseUrl =
								window.location.origin +
								window.location.pathname;

							let url = `${baseUrl}#/print/pdf/estrutura?id=${id}`;

							if (selectedCargo?.value) {
								url += `&cargo_id=${selectedCargo.value}`;
							}

							window.open(url, "_blank");
						}}
					>
						<Printer size={16} /> Imprimir
					</Button>
				</div>
			</Row>

			<Col md="12">
				<Row className="align-items-center">
					<Col md="5">
						<FormGroup className="mb-3">
							<Label>Cargo</Label>
							<Select
								placeholder="Selecione o Cargo"
								onChange={handleChangeCargo}
								value={
									cargos?.find(
										(option) =>
											option.value ===
											selectedCargo?.value,
									) || null
								}
								options={cargos}
								styles={{
									...customStyles,
									menu: (base) => ({
										...base,
										zIndex: 9999999,
									}),
								}}
							/>
						</FormGroup>
					</Col>
					<Col md="12">
						<FormGroup className="mb-3">
							<Label htmlFor="definition">Formação</Label>
							<Input
								type="textarea"
								placeholder="Insira a formação"
								onChange={(e) =>
									handleChangeFieldValue(
										"formation",
										e.target.value,
									)
								}
								disabled={!selectedCargo}
								value={editInfos.formation || ""}
							/>
						</FormGroup>
					</Col>
					<Col md="12">
						<FormGroup className="mb-3">
							<Label htmlFor="definition">Conhecimento</Label>
							<Input
								type="textarea"
								placeholder="Insira o Conhecimento"
								onChange={(e) =>
									handleChangeFieldValue(
										"knowledge",
										e.target.value,
									)
								}
								disabled={!selectedCargo}
								value={editInfos.knowledge || ""}
							/>
						</FormGroup>
					</Col>
					<Col md="12">
						<FormGroup className="mb-3">
							<Label htmlFor="definition">Competência</Label>
							<Input
								type="textarea"
								placeholder="Insira a Competência"
								onChange={(e) =>
									handleChangeFieldValue(
										"competence",
										e.target.value,
									)
								}
								disabled={!selectedCargo}
								value={editInfos.competence || ""}
							/>
						</FormGroup>
					</Col>
					<Col md="12">
						<FormGroup className="mb-3">
							<Label htmlFor="definition">Remuneração</Label>
							<Input
								type="textarea"
								placeholder="Insira a Remuneração"
								onChange={(e) =>
									handleChangeFieldValue(
										"remuneration",
										e.target.value,
									)
								}
								disabled={!selectedCargo}
								value={editInfos.remuneration || ""}
							/>
						</FormGroup>
					</Col>
				</Row>

				<Row className="py-1">
					<div className="hstack gap-2 justify-content-end mb-0">
						<Button
							style={{
								background: "none",
								padding: 10,
								cursor: "pointer",
								color: "black",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								gap: 2,
							}}
							onClick={handleSave}
						>
							<FloppyDisk size={16} /> Salvar
						</Button>
						<Button
							style={{
								background: "none",
								padding: 10,
								cursor: "pointer",
								color: "black",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								gap: 2,
							}}
							onClick={onCloseClick}
						>
							<SignOut size={16} /> Fechar
						</Button>
					</div>
				</Row>
			</Col>
		</>
	);
};

CaracteristicaCargo.propTypes = {
	onCloseClick: PropTypes.func,
	data: PropTypes.any,
};

export default CaracteristicaCargo;
